import { useMemo } from 'react';

import type { Apollo } from 'src/gql/generated';
import { Apollo as ApolloHooks } from 'src/gql/generated';

export type ColumnOptionSubset =
  | Pick<Apollo.ExtractionReportColumn, '__typename' | 'displayName' | 'questionId'>
  | Pick<Apollo.FileFieldColumn, '__typename' | 'displayName' | 'field'>;

export function buildColumnMap(columnOptions: readonly ColumnOptionSubset[]): Map<string, string> {
  return new Map<string, string>(
    columnOptions.map(col => [
      col.__typename === 'ExtractionReportColumn' ? col.questionId : col.field,
      col.displayName,
    ])
  );
}

export function useReportColumnMap(reportId?: string): Map<string, string> {
  const { data } = ApolloHooks.useGetReportInitialStateQuery({
    skip: !reportId,
    variables: { reportId: reportId ?? '' },
  });

  return useMemo(
    () => buildColumnMap(data?.report?.columnOptions ?? []),
    [data?.report?.columnOptions]
  );
}
